import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    Description,
    EmptyState,
    EmptyStateActions,
    EmptyStateIcon,
    EmptyStateNotFoundHeading,
} from '@gitbook/spine-react';

/**
 * Full-screen component when a change request doesn't exist or has been deleted.
 */
export function ChangeRequestNotFound(): React.ReactElement {
    return (
        <EmptyState>
            <EmptyStateIcon>
                <Icon.ChangeRequest />
            </EmptyStateIcon>
            <EmptyStateNotFoundHeading />
            <Description>
                The change request you are trying to access doesn't exist or may have been deleted.
            </Description>
            <EmptyStateActions>
                <Button
                    kind="secondary"
                    size="medium"
                    href={{
                        current: {
                            changeRequest: undefined,
                            sideSheet: { type: 'change-requests' },
                        },
                    }}
                    label="View change requests"
                />
            </EmptyStateActions>
        </EmptyState>
    );
}
